import React, { createContext, useMemo, useState, type PropsWithChildren } from 'react';
import noop from 'lodash/noop';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import type { DataState as MediaUploadPermissionsDataState } from '../media-upload-permissions/types.tsx';
import type { DataState as OperationsAndActionsDataState } from '../operations-and-actions/types.tsx';

type ContextValue = {
	operationsAndActions: [
		OperationsAndActionsDataState,
		React.Dispatch<React.SetStateAction<OperationsAndActionsDataState>>,
	];
	mediaUploadPermissions: [
		MediaUploadPermissionsDataState,
		React.Dispatch<React.SetStateAction<MediaUploadPermissionsDataState>>,
	];
};

const initialState: ContextValue = {
	operationsAndActions: [
		{
			loading: false,
			loadFieldResources: noop,
		},
		noop,
	],
	mediaUploadPermissions: [
		{
			loading: false,
			error: false,
			permissions: null,
		},
		noop,
	],
};

export const issueOperationsCacheContext = createContext<ContextValue>(initialState);

const IssueOperationsCacheProviderInner = ({ children }: PropsWithChildren<{}>) => {
	const [operationsAndActions, setOperationsAndActions] = useState<OperationsAndActionsDataState>(
		initialState.operationsAndActions[0],
	);
	const [mediaUploadPermissions, setMediaUploadPermissions] =
		useState<MediaUploadPermissionsDataState>(initialState.mediaUploadPermissions[0]);

	const value = useMemo<ContextValue>(
		() => ({
			operationsAndActions: [operationsAndActions, setOperationsAndActions],
			mediaUploadPermissions: [mediaUploadPermissions, setMediaUploadPermissions],
		}),
		[operationsAndActions, mediaUploadPermissions],
	);

	return (
		<issueOperationsCacheContext.Provider value={value}>
			{children}
		</issueOperationsCacheContext.Provider>
	);
};

export const IssueOperationsCacheProvider = componentWithFG(
	'empanada_nin_convert_issue_ops_to_entrypoint',
	IssueOperationsCacheProviderInner,
	(props: PropsWithChildren<{}>) => <>{props.children}</>,
);
